import { render, staticRenderFns } from "./MortalidadNew.vue?vue&type=template&id=d1745bac"
import script from "./MortalidadNew.vue?vue&type=script&lang=js"
export * from "./MortalidadNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports